const getContentProps = (postType, type = "") => {
	const aliases = {
		pageVideoSeries: {
			type: "series",
			typePlaceholder: "VIDEO SERIES",
			alias: "/series",
			linkPlaceholder: "Watch Series",
		},
		pageGuides: {
			type: "guides",
			typePlaceholder: "GUIDE",
			alias: "/guides",
			linkPlaceholder: "Read Guide",
		},
		pageGuide: {
			type: "guides",
			typePlaceholder: "GUIDE",
			alias: "/guides",
			linkPlaceholder: "Read Guide",
		},
		pageWebinar: {
			type: "webinars",
			alias: "/webinars",
			linkPlaceholder: type.toLowerCase() === "on demand" ? "Watch Now" : "Register Now",
		},
		pageIntegration: {
			type: "integrations",
			alias: "/integrations",
			linkPlaceholder: "Learn More",
		},
		atomLink: {
			linkPlaceholder: "Learn More",
		},
		pageExternal: {
			type: "external",
			alias: "",
		},
		pageBlog: {
			type: "blog",
			alias: "/blog",
		},
		pagePlugins: {
			type: "plugins",
			alias: "/plugins",
		},
		pageTutorial: {
			type: "tutorial",
			typePlaceholder: "TUTORIAL",
			alias: "/tutorials",
			linkPlaceholder: "Read Tutorial",
		},
		pageProduct: {
			type: "features",
			typePlaceholder: "FEATURES",
			alias: "/features",
			linkPlaceholder: "Read More",
		},
	};

	return aliases[postType] || false;
};

export default getContentProps;
